import Button from 'flarum/common/components/Button';
import Switch from 'flarum/common/components/Switch';
import Stream from 'flarum/common/utils/Stream';
import app from 'flarum/forum/app';
import UserPage from 'flarum/forum/components/UserPage';
const trans = key => {
  return app.translator.trans(`nearata-minecraft-avatars.forum.${key}`);
};
export default class MinecraftAvatarsPage extends UserPage {
  oninit(vnode) {
    super.oninit(vnode);
    this.show(app.session.user);
    this.switchLoading = false;
    this.loading = false;
    this.avatar = Stream(this.user.attribute('minotar') || '');
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    app.setTitle(trans('page_title').toString());
  }
  content() {
    return m("div", {
      class: "MinecraftAvatarsPage"
    }, m("div", {
      class: "Form"
    }, m("div", {
      class: "Form-group"
    }, m("input", {
      class: "FormControl",
      type: "text",
      name: "minotar",
      placeholder: trans('placeholder'),
      autocomplete: "off",
      bidi: this.avatar
    }), m("p", {
      class: "helpText"
    }, trans('help_text'))), m("div", {
      class: "Form-group"
    }, m(Button, {
      class: "Button Button--primary Button--block",
      disabled: this.loading || this.avatar() === this.user.attribute('minotar') || this.avatar().length < 3,
      onclick: this.onButtonClick.bind(this)
    }, trans('submit_button'))), m("div", {
      class: "Form-group"
    }, m(Switch, {
      state: this.user.attribute('minotarEnabled'),
      loading: this.switchLoading,
      disabled: this.switchLoading,
      onchange: this.onSwitchChange.bind(this)
    }, trans('minotar_enabled')))));
  }
  onButtonClick(e) {
    this.loading = true;
    this.user.save({
      minotar: this.avatar()
    }).then(() => {
      // @ts-expect-error
      delete this.user.avatarColor;
      this.avatar(this.user.attribute('minotar'));
    }).catch(e => console.error(e)).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
  onSwitchChange(value) {
    this.switchLoading = true;
    this.user.save({
      minotarEnabled: value
    }).then(() => {
      // @ts-expect-error
      delete this.user.avatarColor;
    }).catch(e => console.error(e)).finally(() => {
      this.switchLoading = false;
      m.redraw();
    });
  }
}
flarum.reg.add('nearata-minecraft-avatars', 'forum/components/MinecraftAvatarsPage', MinecraftAvatarsPage);